<template>
  <div class="elementWidths" :key="`tab_content_4` + $store.state.calculatorData.calculatorPages[4].disabled + `_errors_` + $store.state.calculatorData.calculatorPages[4].errors">
    <div class="row">
      <div class="col-md-6">
        <h2>{{ $t(`elementWidths.title`)}}</h2>
      </div>
      <div class="col-md-6 md-align-right" v-if="elementForm !== ''">
        <p>({{$t(`globals.currentSelectedForm`)}} <strong> {{$t(`elementForm.`+ elementForm +`.pdfTitle`)}}</strong>)</p>
      </div>
    </div>

    <b-button @click="explanationClick()" v-b-toggle.explanation-content-elementWidths variant="primary" class="explanation"> <span v-html="$t(`globals.explanation`)"></span></b-button>
    <b-collapse id="explanation-content-elementWidths" class="explanation-content">
      <b-card>
        <p v-html="$t('elementWidths.infoText')"></p>
      </b-card>
    </b-collapse>
    <div class="row" >
      <div class="technical-draw col-md-5 d-none d-md-block align-self-center">
        <TechnicalDrawing step="elementWidths" :type="`elementwidths_`+elementForm" />
      </div>
      <div class="col-md-7">

        <div class="technical-draw d-md-none">
          <TechnicalDrawing step="elementWidths" :type="`elementwidths_`+elementForm" />
        </div>
        <div v-if="elementForm !== ''">
          <StoSlider name="b" tab="elementWidths" />
          <div
            v-if="elementForm === 'jaka'"
            class="slider-wrapper input-container highlight-box"
            @mouseenter="mouseEnter('e')"
            @mouseleave="mouseLeave('e')"
          >
            <div class="row space-between">
              <div class="col-12">
                <span v-html="$t(`variablesNice.e`)"></span>
              </div>
              <div class="col-12">
                <div class="jaka-e-radio-group">
                  <label
                    v-for="option in jakaEOptions"
                    :key="`jaka-e-option-${option}`"
                    class="jaka-e-radio-option"
                    :class="{ active: e === option }"
                    :for="`jaka-e-option-${option}`"
                  >
                    <input
                      :id="`jaka-e-option-${option}`"
                      type="radio"
                      name="jaka-e-option"
                      :checked="e === option"
                      @change="updateJakaE(option)"
                    />
                    <span>{{ option }} mm</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <StoSlider v-else name="e" tab="elementWidths" />

          <div
            v-if="isBox"
            class="slider-wrapper input-container highlight-box calculated-box"
            :class="{ 'disabled': elementForm === 'jaka' }"
            @mouseenter="mouseEnter('w')"
            @mouseleave="mouseLeave('w')"
          >
            <div class="row space-between">
              <div class="col-md-8">
                  <span v-html="$t(`variablesNice.w`)"></span>
                  <p>W  = B - E - H </p>
                  <p v-if="vacuumPanels === 'vip'" > Enthält 20mm VIP</p>
              </div>
              <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
                <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
              </div>
              <div class="col-md-4 d-none d-md-block">
                <input type="number" :min="min" :max="max" :value="w" class="slider-input disabled" disabled="disabled"> mm
              </div>

              <div v-if="$store.state.calculatorData.errors['w'] === 'min'" class="col-12 error">
                {{$tc(`elementWidths.werrorMin`, min, {min: calculatorMin.w()})}}
              </div>
              <div v-if="$store.state.calculatorData.errors['w'] === 'max'" class="col-12 error">
                {{$tc(`elementWidths.werrorMax`, max, {max: calculatorMax.w()})}}
              </div>
            </div>
          </div>

          <div
            class="slider-wrapper input-container highlight-box calculated-box"
            @mouseenter="mouseEnter('h')"
            @mouseleave="mouseLeave('h')"
          >
            <div class="row space-between">
              <div class="col-md-8">
                  <span v-html="$t(`variablesNice.h`)"></span>
              </div>
              <div class="col-12 d-md-none text-align-right spacebottom-to-sm">
                <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
              </div>
              <div class="col-md-4 d-none d-md-block">
                <input type="number" :min="min" :max="max" :value="h" class="slider-input disabled" disabled="disabled"> mm
              </div>
            </div>
          </div>

        </div>
        <div class="info-wrapper">
          <div v-if="$store.state.calculatorData.warnings.elementWidths">
            <p v-if="$store.state.calculatorData.warnings.elementWidths.eIs100" class="info" v-html="$t('elementWidths.triggerInfo2')"></p>
            <!-- <p v-if="$store.state.calculatorData.warnings.elementWidths.eIsLowerThanEquals115" class="info" v-html="$t('elementWidths.eIsLowerThanEquals115')"></p> -->
            <p v-if="$store.state.calculatorData.warnings.elementWidths.widerThanStandard" class="info" v-html="$t('elementWidths.triggerInfo3')"></p>
          </div>
        </div>
      </div>
    </div>
    <StepNavi thisPage="5" :key="`navi_tab5_`+ $store.state.calculatorData.calculatorPages[5].disabled"/>
  </div>
</template>

<script>
import StoSlider from './StoSlider.vue'
import TechnicalDrawing from './TechnicalDrawing.vue'
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    StoSlider,
    TechnicalDrawing,
    StepNavi
  },
  data () {
    return {
      min: Number,
      max: Number,
      textTriggerOpen: false
    }
  },
  computed: {
    ...mapGetters([
      'b',
      'e',
      'w',
      'h',
      'isBox',
      'calculatorMin',
      'calculatorMax',
      'elementForm',
      'vacuumPanels'
    ]),
    jakaEOptions: function () {
      const min = 140
      const max = 300
      const step = 20
      const parsedB = parseInt(this.b)
      const safeB = isNaN(parsedB) ? min : parsedB
      const clampedB = Math.min(Math.max(safeB, min), max)
      const normalizedB = min + Math.round((clampedB - min) / step) * step
      if (normalizedB === 140) {
        return [100]
      }
      if (normalizedB === 160) {
        return [100, 120]
      }
      return [120, 140]
    }
  },
  methods: {
    mouseEnter: function (name) {
      var list = document.getElementsByClassName('highlight-' + name)
      for (var i = 0; i < list.length; i++) {
        list[i].classList.add('active')
      }
    },
    mouseLeave: function (name) {
      var list = document.getElementsByClassName('highlight-' + name)
      for (var i = 0; i < list.length; i++) {
        list[i].classList.remove('active')
      }
    },
    updateJakaE: function (value) {
      const rootApp = this.$root && this.$root.$children && this.$root.$children['0']
      if (rootApp) {
        rootApp.userDidAction = true
      }
      this.$store.dispatch('didInputFkt', {
        key: 'e',
        value: value,
        validate: true
      })
    },
    explanationClick: function () {
      if (this.textTriggerOpen) {
        this.textTriggerOpen = false
      } else {
        this.$root.$children['0'].userDidAction = true
        this.textTriggerOpen = true
        let tabName = 'elementWidths'
        let gtmEventLabel = this.$(tabName + '.virtualPageTitle')
        let virtualPageURL = '/' + this.$t(tabName + '.virtualPageURL')
        let virtualPageTitle = this.$t(tabName + '.virtualPageTitle')
        this.$root.$children['0'].globalGTMFkt('JKK-Events', 'Erläuterung', 'Button', gtmEventLabel, '', virtualPageURL, virtualPageTitle)
      }
    }
  },
  mounted: function () {
    // console.log('--- elementWidths rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.jaka-e-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.75rem;
}

.jaka-e-radio-option {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 130px;
  margin: 0;
  padding: 0.75rem 1rem;
  border: 2px solid #b8b8b8;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.jaka-e-radio-option input {
  position: absolute;
  inset: 0;
  opacity: 0;
  margin: 0;
  cursor: pointer;
}

.jaka-e-radio-option span {
  font-size: 2rem;
  line-height: 1.2;
}

.jaka-e-radio-option.active {
  border-color: #7a7a7a;
  background: #d3d3d3;
}

</style>
